import React, { Fragment } from 'react';
import { Heading, Layout } from '@americanexpress/dls-react';
import { IconAddCard, IconBank, IconPound } from '@americanexpress/dls-icons';
import { HOME_PAGE } from '../../copyText/newUserPage';

export default function Home() {
  return (
    <Fragment>
      <Layout innerContainerClassName="pad-4" variant="card">
        <Heading level={1} variant="sans-xlarge-book" className="margin-1-b">{HOME_PAGE.CARD_1.H1}</Heading>
        <p className="margin-3-b">{HOME_PAGE.CARD_1.P0}</p>
        <div className="margin-2-b">
          <Heading level={2} variant="sans-xsmall-bold">{HOME_PAGE.CARD_1.ITEM1.TITLE}</Heading>
          <p>{HOME_PAGE.CARD_1.ITEM1.P1}</p>
          <ul className="pad-1-b">
            <li>{HOME_PAGE.CARD_1.ITEM1.LI1}</li>
            <li>{HOME_PAGE.CARD_1.ITEM1.LI2}</li>
            <li>{HOME_PAGE.CARD_1.ITEM1.LI3}</li>
          </ul>
          <p className="pad-3-b">{HOME_PAGE.CARD_1.ITEM1.P2}</p>

          <Heading level={2} variant="sans-xsmall-bold">{HOME_PAGE.CARD_1.ITEM2.TITLE}</Heading>
          <p>{HOME_PAGE.CARD_1.ITEM2.P1}</p>
          <ul className="pad-3-b">
            <li>{HOME_PAGE.CARD_1.ITEM2.LI1}</li>
            <li>{HOME_PAGE.CARD_1.ITEM2.LI2}</li>
            <li>{HOME_PAGE.CARD_1.ITEM2.LI3}</li>
            <li>{HOME_PAGE.CARD_1.ITEM2.LI4}</li>
          </ul>

          <Heading level={2} variant="sans-xsmall-bold">{HOME_PAGE.CARD_1.ITEM3.TITLE}</Heading>
          <p>{HOME_PAGE.CARD_1.ITEM3.P1}</p>
          <p>{HOME_PAGE.CARD_1.ITEM3.P2}</p>
          <p>{HOME_PAGE.CARD_1.ITEM3.P3}</p>
        </div>
      </Layout>

      <Layout innerContainerClassName="pad-4 margin-4-tb" variant="card">
        <div className="flex flex-align-items-baseline margin-2-b">
          <Heading level={1} variant="sans-xlarge-book" className="margin-4-r">{HOME_PAGE.CARD_2.H1}</Heading>
          <Heading level={2} variant="sans-medium-regular" className="dls-bright-blue">{HOME_PAGE.CARD_2.H2}</Heading>
        </div>
        <div className="row">
          <div className="col-md-4 flex flex-align-items-stretch">
            <Layout innerContainerClassName="pad-3 dls-gray-01-bg" variant="card">
              <div className="flex flex-align-items-center pad-1-b">
                <IconAddCard size="lg" className="pad-1-r" />
                <Heading level={2} variant="sans-small-bold">{HOME_PAGE.CARD_2.ITEM1.TITLE}</Heading>
              </div>
              <p>{HOME_PAGE.CARD_2.ITEM1.P}</p>
            </Layout>
          </div>
          <div className="col-md-4 flex flex-align-items-stretch">
            <Layout innerContainerClassName="pad-3 dls-gray-01-bg" variant="card">
              <div className="flex flex-align-items-center pad-1-b">
                <IconBank size="lg" className="pad-1-r" />
                <Heading level={2} variant="sans-small-bold">{HOME_PAGE.CARD_2.ITEM2.TITLE}</Heading>
              </div>
              <p>{HOME_PAGE.CARD_2.ITEM2.P}</p>
              <ul>
                <li>{HOME_PAGE.CARD_2.ITEM2.LI1}</li>
                <li>{HOME_PAGE.CARD_2.ITEM2.LI2}</li>
              </ul>
            </Layout>
          </div>
          <div className="col-md-4 flex flex-align-items-stretch">
            <Layout innerContainerClassName="pad-3 dls-gray-01-bg" variant="card">
              <div className="flex flex-align-items-center pad-1-b">
                <IconPound size="lg" className="pad-1-r" />
                <Heading level={2} variant="sans-small-bold">{HOME_PAGE.CARD_2.ITEM3.TITLE}</Heading>
              </div>
              <p>{HOME_PAGE.CARD_2.ITEM3.P1}</p>
              <ul>
                <li>{HOME_PAGE.CARD_2.ITEM3.LI1}</li>
                <li>{HOME_PAGE.CARD_2.ITEM3.LI2}</li>
                <li>{HOME_PAGE.CARD_2.ITEM3.LI3}</li>
              </ul>
              <p>{HOME_PAGE.CARD_2.ITEM3.P2}</p>
            </Layout>
          </div>
        </div>
        <p className="margin-3-t">{HOME_PAGE.FAQ('a link')}</p>
      </Layout>
    </Fragment>
  );
}
